function getUrl(path) {
  return `//checkapi.aliyun.com/check//${path}`;
}

export default class Service {

  constructor(feature) {
    this.feature = feature;
  }

  async getRecommend(keyword, params = {}) {
    params.pageSize = params.pageSize || 6;
    params.offset = params.offset || 0;
    const url = getUrl('checkrecommend');
    let result = await this.feature.request.send(url,
      { keyword, ...params }, {
        loading: false,
        ignoreError: true
      });
    if (!result) return [];
    return Promise.all(
      result.map(item => this.feature.service.convertCheckItem(item))
    );
  }

}


// WEBPACK FOOTER //
// ./src/recommend/service.js